import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from './api.service';
import {
  PuroReservation,
  ValamarBooking,
  CompleteDailyCheckinRequest,
  CompleteDailyCheckinResponse,
  CreateWalkInRequest, CreateWalkInResponse
} from '../models';

/**
 * Service for reservation-related API calls
 */
@Injectable({
  providedIn: 'root'
})
export class ReservationService {
  constructor(private apiService: ApiService) {}

  /**
   * Get Puro reservation by reservation code
   * GET /api/v1/Reservation/reservationCode/{reservationCode}
   */
  getReservationByCode(reservationCode: string): Observable<PuroReservation> {
    return this.apiService.get<PuroReservation>(`/api/v1/PuroReservation/${reservationCode}`);
  }

  updateReservation(reservation: PuroReservation): Observable<PuroReservation> {
    return this.apiService.put<PuroReservation>(
      `/api/v1/PuroReservation`,
      reservation
    );
  }

  /**
   * Get Puro reservation by reservation code
   * GET /api/v1/Reservation/reservationCode/{reservationCode}
   */
  transferReservationToDailyVirtual(resvNameId: string): Observable<any> {
    return this.apiService.get<PuroReservation>(`/api/v1/PuroReservation/transfer/${resvNameId}`);
  }

  /**
   * Complete daily check-in - creates gastro master/additional cards and daily transfer
   * POST /api/v1/PuroReservation/complete-daily-checkin
   */
  completeDailyCheckin(request: CompleteDailyCheckinRequest): Observable<CompleteDailyCheckinResponse> {
    return this.apiService.post<CompleteDailyCheckinResponse>(
      `/api/v1/PuroReservation/complete-daily-checkin`,
      request
    );
  }

  /**
   * Search Valamar bookings by property, arrival date, departure date, and room number
   * GET /api/v2/Reservation/BookingsByPropertyArrivalDateDepartureDateAndRoomNumber
   */
  searchValamarBookings(params: {
    propertyCode: string;
    roomNumber: string;
  }): Observable<ValamarBooking[]> {
    const queryParams = new URLSearchParams({
      propertyCode: params.propertyCode,
      roomNumber: params.roomNumber
    });

    return this.apiService.get<ValamarBooking[]>(
      `/api/v1/Booking/search?${queryParams.toString()}`
    );
  }

  /**
   * Get Puro reservation by wristband (additional card) ID
   * GET /api/v1/PuroReservation/by-additional-card/{cardId}
   */
  getReservationByWristband(wristbandId: string): Observable<PuroReservation[]> {
    return this.apiService.get<PuroReservation[]>(`/api/v1/PuroReservation/by-additional-card/${wristbandId}`);
  }

  /**
   * Create a new walk-in reservation
   * POST /api/v1/PuroReservation/walk-in
   */
  createWalkInReservation(request: CreateWalkInRequest): Observable<CreateWalkInResponse> {
    return this.apiService.post<CreateWalkInResponse>(
      `/api/v1/PuroReservation/create-walk-in`,
      request
    );
  }
}
